import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import awsConfig from './config';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import InvoiceList from './components/InvoiceList';
import InvoiceForm from './components/InvoiceForm';
import InvoiceDetail from './components/InvoiceDetail';
import ApprovalQueue from './components/ApprovalQueue';
import UserManagement from './components/UserManagement';
import MasterDataManagement from './components/MasterDataManagement';
import AfipCertificates from './components/AfipCertificates';
import Navbar from './components/Navbar';
import './App.css';

const normalizeUserPermissions = (userData) => {
  if (!userData) return userData;
  const role = userData.role;
  const defaultPermission = role !== 'administrador';
  return {
    ...userData,
    canCreateInvoices: userData.canCreateInvoices ?? defaultPermission,
    canEditInvoices: userData.canEditInvoices ?? defaultPermission,
    canManageMasterData: userData.canManageMasterData ?? (role === 'administrador')
  };
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    
    if (storedUser && token) {
      setUser(normalizeUserPermissions(JSON.parse(storedUser)));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    const normalizedUser = normalizeUserPermissions(userData);
    localStorage.setItem('user', JSON.stringify(normalizedUser));
    localStorage.setItem('token', token);
    setUser(normalizedUser);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    setUser(null);
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <Router>
      <div className="App">
        {user && <Navbar user={user} onLogout={handleLogout} />}
        
        <Routes>
          {!user ? (
            <>
              <Route path="/login" element={<Login onLogin={handleLogin} />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Dashboard user={user} />} />
              <Route path="/invoices" element={<InvoiceList user={user} />} />
              {user.canCreateInvoices && <Route path="/invoices/new" element={<InvoiceForm user={user} />} />}
              <Route path="/invoices/:id" element={<InvoiceDetail user={user} />} />
              {(user.role === 'supervisor' || user.role === 'administrador') && (
                <Route path="/approval" element={<ApprovalQueue user={user} />} />
              )}
              {user.role === 'administrador' && (
                <Route path="/users-management" element={<UserManagement user={user} />} />
              )}
              {user.role === 'administrador' && (
                <Route path="/afip-certificates" element={<AfipCertificates />} />
              )}
              {user.canManageMasterData && (
                <Route path="/masterdata-management" element={<MasterDataManagement user={user} />} />
              )}
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
